import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import FilterSidebar from './components/FilterSidebar';
import ProductGrid from './components/ProductGrid';
import Footer from '../home/components/Footer';

export default function ShopPage() {
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [selectedSizes, setSelectedSizes] = useState<string[]>([]);
  const [priceRange, setPriceRange] = useState<[number, number]>([0, 500]);
  const [sortBy, setSortBy] = useState<string>('featured');

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />
      
      {/* Page Header */}
      <div className="pt-32 pb-16 px-8 border-b border-white/10">
        <div className="max-w-[1600px] mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div>
              <p className="text-xs font-bold tracking-[0.15em] uppercase text-gray-400 mb-3">
                FULL COLLECTION
              </p>
              <h1 className="text-6xl md:text-7xl font-black text-white">Shop All</h1>
            </div>
            
            {/* Desktop Sort */}
            <div className="hidden md:flex items-center gap-4">
              <span className="text-sm text-gray-400">Sort by:</span>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="bg-[#1A1A1A] text-white border border-white/20 rounded-lg px-4 py-2 text-sm font-medium cursor-pointer hover:border-white/40 transition-colors"
              >
                <option value="featured">Featured</option>
                <option value="newest">Newest</option>
                <option value="price-low">Price: Low to High</option>
                <option value="price-high">Price: High to Low</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-[1600px] mx-auto px-8 py-12">
        <div className="flex gap-8">
          {/* Desktop Filter Sidebar */}
          <div className="hidden lg:block w-64 flex-shrink-0">
            <FilterSidebar
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              selectedSizes={selectedSizes}
              setSelectedSizes={setSelectedSizes}
              priceRange={priceRange}
              setPriceRange={setPriceRange}
            />
          </div>

          {/* Product Grid */}
          <div className="flex-1">
            {/* Mobile Controls */}
            <div className="lg:hidden mb-8 flex gap-3">
              <button
                onClick={() => setIsMobileFilterOpen(true)}
                className="flex-1 bg-[#1A1A1A] text-white border border-white/20 rounded-lg px-4 py-3 text-sm font-bold hover:border-white/40 transition-colors whitespace-nowrap"
              >
                <i className="ri-filter-3-line mr-2"></i>
                FILTERS
              </button>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="flex-1 bg-[#1A1A1A] text-white border border-white/20 rounded-lg px-4 py-3 text-sm font-bold cursor-pointer hover:border-white/40 transition-colors"
              >
                <option value="featured">Featured</option>
                <option value="newest">Newest</option>
                <option value="price-low">Price: Low to High</option>
                <option value="price-high">Price: High to Low</option>
              </select>
            </div>

            <ProductGrid
              selectedCategory={selectedCategory}
              selectedSizes={selectedSizes}
              priceRange={priceRange}
              sortBy={sortBy}
            />
          </div>
        </div>
      </div>

      {/* Mobile Filter Modal */}
      {isMobileFilterOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div
            className="absolute inset-0 bg-black/80"
            onClick={() => setIsMobileFilterOpen(false)}
          ></div>
          <div className="absolute right-0 top-0 bottom-0 w-full max-w-sm bg-[#0A0A0A] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-8">
                <h2 className="text-2xl font-black text-white">Filters</h2>
                <button
                  onClick={() => setIsMobileFilterOpen(false)}
                  className="w-10 h-10 flex items-center justify-center text-white hover:bg-white/10 rounded-lg transition-colors"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <FilterSidebar
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                selectedSizes={selectedSizes}
                setSelectedSizes={setSelectedSizes}
                priceRange={priceRange}
                setPriceRange={setPriceRange}
              />
              <button
                onClick={() => setIsMobileFilterOpen(false)}
                className="w-full mt-8 bg-white text-black py-4 rounded-lg font-bold text-sm tracking-wide hover:scale-105 transition-all duration-300 whitespace-nowrap"
              >
                APPLY FILTERS
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}